import { render } from "./Stats.vue?vue&type=template&id=61ac1cf9&scoped=true"
import script from "./Stats.vue?vue&type=script&lang=ts"
export * from "./Stats.vue?vue&type=script&lang=ts"

import "./Stats.vue?vue&type=style&index=0&id=61ac1cf9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-61ac1cf9"

export default script